export default __webpack_public_path__ + "static/media/G3ESS_150.d98703ab.jpg";